<template>
  <span class="fd_badge js-tooltip label label-warning" data-title="Fuori dispenser"> FD </span>
</template>
<script>
export default {
  name: 'fdLabel',
};
</script>
